import { useInlineArcadeComponentsEnabled, useIsExpress, useIsShippingOptionRequired, useShippingOption } from '../../state'
import { ShippingOptionStatus } from '../../model'
import { Theme, useIsTheme } from '@afterpaytouch/core'

export const useShouldShowShippingMessage = (): boolean => {
  const isExpress = useIsExpress()
  const isShippingOptionRequired = useIsShippingOptionRequired()
  const { shippingOptionsStatus } = useShippingOption()
  const isAPTheme = useIsTheme(Theme.AP)
  const isInlineArcadeComponentsEnabled = useInlineArcadeComponentsEnabled()

  const isShippingOptionNotSelected =
    isShippingOptionRequired && (shippingOptionsStatus < ShippingOptionStatus.UpdatingSelected || shippingOptionsStatus === ShippingOptionStatus.Error)
  const isCashThemeShippingOptionNotSelected = !isAPTheme && isShippingOptionNotSelected

  if (!isExpress) {
    return false
  }

  if (isInlineArcadeComponentsEnabled) {
    return false
  }

  // Don't show message when is cash theme and shipping option has not been selected yet
  if (isCashThemeShippingOptionNotSelected) {
    return false
  }

  // Show message if either:
  // - shipping option is required but not selected yet, or
  // - shipping option is not required
  return isShippingOptionNotSelected || !isShippingOptionRequired
}
